import type { Router } from 'vue-router';
import { EntityCache } from '@sysarb/sysarb-api/cache';
import { EventService } from '@/services/EventService';
import { usePayAuditEntityStore } from '@/store/salarySurvey/payAuditEntityStore';
import { useNotificationStore } from '@/store/notificationStore';
import { useGridStore } from '@/store/gridStore';
import { useAnalyzeEqualWorkStore } from '@/views/payEquityAudit/analyzeV2/AnalyzeEqualWorkStore';

/**
 * Clears in-memory data that can still hold personal data from the previous role or setting.
 * Pages load it again when they mount.
 */
export async function clearCachedPersonalData(router: Router): Promise<void> {
    const eventService = EventService.getInstance(router);
    if (eventService.subscriptions.value.length > 0) await eventService.unsubscribeAll();
    EntityCache.clear();
    usePayAuditEntityStore().$reset();
}

/**
 * Clears stored data a user would see again. Only used for a role that may not see personal data,
 * so other roles keep their notifications, selection and grid filters.
 */
export function clearStoredPersonalData(): void {
    useNotificationStore().clear();
    useGridStore().clearSearchAndFilters();

    const analyzeEqualWorkStore = useAnalyzeEqualWorkStore();
    analyzeEqualWorkStore.setSelectedEmploymentId(null);
    analyzeEqualWorkStore.setSelectedEmployment(null);
}
